export default __webpack_public_path__ + "static/media/credit-card-rafiki.fcde2f15.png";